import { render, staticRenderFns } from "./ModalSelectSubject.vue?vue&type=template&id=2041a364&scoped=true&lang=pug&"
import script from "./ModalSelectSubject.vue?vue&type=script&lang=ts&"
export * from "./ModalSelectSubject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2041a364",
  null
  
)

export default component.exports